import React, { createContext, useContext, useEffect, useState } from 'react';
import { authApi } from '../../../api/authApi';

const TOKEN_KEY = 'diploAccessKey';
const USER_KEY = 'diploAccessUser';

const readStoredUser = () => {
  const user = localStorage.getItem(USER_KEY);
  return user && localStorage.getItem(TOKEN_KEY) ? user : null;
};

const AuthContext = createContext(null);

/**
 * `user` is the stored login (email) and is set only while a token exists;
 * `userProfile` is /users/me, loaded once per page load.
 */
export function AuthProvider({ children }) {
  const [user, setUser] = useState(readStoredUser);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    const sync = () => setUser(readStoredUser());
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);

  useEffect(() => {
    if (!user) return;
    authApi.getCurrentUser()
      .then(setUserProfile)
      .catch((error) => console.warn('Could not load user profile:', error.message));
  }, [user]);

  const logout = async () => {
    await authApi.logout();
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    window.location.reload();
  };

  return (
    <AuthContext.Provider value={{ user, userProfile, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
